export default {
  remote: 'simplify_hub_github_ingestion_tracker_mfe',
  name: 'github-ingestion-tracker',
  source: 'https://github.com/telus/simplify-mfe-components',
  urlMapping: {
    localhost: 'http://localhost:4342/mf-manifest.json',
    'simplify.developers.telus.digital': 'https://assets.wcpreview.telus.com/1100769639/simplify-github-ingestion-tracker/v1/mf2/mf-manifest.json',
    'simplify.staging.developers.telus.digital': 'https://assets.wcstage.telus.com/1100769639/simplify-github-ingestion-tracker/v1/mf2/mf-manifest.json',
    'simplify.telus.com': 'https://assets.telus.com/1100769639/simplify-github-ingestion-tracker/v1/mf2/mf-manifest.json',
  },
};
